import reducer from "./reducer";
export { default as FamilyAsignations } from "./components/index";
export { default as familyAsignationsReducerName } from "./constants";
export default reducer;
